/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";

export default baustein.register("snow", {
    onInsert: function() {
        this.ctx = this.el.getContext("2d");

        var W = this.el.parentElement.offsetWidth;
        var H = this.el.parentElement.offsetHeight;

        this.el.width = W;
        this.el.height = H;

        this.baseFontSize = 8;
        this.angle = 0.0;
        this.particles = [];
        this.maxParticles = 25;
        this.particleWidth = 25;

        for (var i = 0; i < this.maxParticles; i++) {
            this.particles.push({
                x: Math.random() * W,
                y: Math.random() * H,
                r: Math.random() * 5,
                d: Math.random() * this.maxParticles
            });
        }

        this.animId = window.requestAnimationFrame(this._draw.bind(this));
    },

    onRemove: function() {
        this.ctx = null;
    },

    _draw: function() {
        if (!this.ctx) {
            return;
        }

        this.ctx.clearRect(0, 0, this.el.offsetWidth, this.el.offsetHeight);

        this.ctx.fillStyle = "rgba(255, 255, 255, 0.8)";
        this.ctx.beginPath();
        for (var i = 0; i < this.maxParticles; i++) {
            let p = this.particles[i];
            let font = "serif";
            if (i % 2) {
                font = "sans-serif";
            }

            this.ctx.moveTo(p.x, p.y);
            this.ctx.font = this.baseFontSize + p.r * 3 + "px " + font;
            this.ctx.fillText("*", p.x, p.y);
        }
        this.ctx.fill();
        this._update();

        this.animId = window.requestAnimationFrame(this._draw.bind(this));
    },

    _update: function() {
        var W = this.el.offsetWidth;
        var H = this.el.offsetHeight;
        this.angle += 0.001;

        for (var i = 0; i < this.maxParticles; i++) {
            var p = this.particles[i];
            p.y += Math.cos(this.angle + p.d) + 1.0 + p.r / 7;
            p.x += Math.sin(this.angle) * 2;

            // off-canvas repositioning of particles
            if (
                p.x > W + this.particleWidth ||
                p.x < -this.particleWidth ||
                p.y > H + this.particleWidth
            ) {
                this.particles[i] = this._stepParticle(i);
            }
        }
    },

    _stepParticle: function(i) {
        var p = this.particles[i];
        var W = this.el.offsetWidth;
        var H = this.el.offsetHeight;

        if (i % 3 > 0) {
            return {
                x: Math.random() * W,
                y: -10,
                r: p.r,
                d: p.d
            };
        } else if (Math.sin(this.angle) > 0) {
            return {
                x: -5,
                y: Math.random() * H,
                r: p.r,
                d: p.d
            };
        } else {
            return {
                x: W + 5,
                y: Math.random() * H,
                r: p.r,
                d: p.d
            };
        }
    }
});

